import axios from "axios"

const AGENT_SESSION_PATH = "/dash/agent_auth/session"

/* The SDK calls this again near expiry and after a 401, so each call must mint a fresh
   grant instead of handing back a cached one. Authorization and COMPANY-KEY ride the
   axios defaults the app sets from the Keycloak session, and the dash_api route behind
   this path demands the access_agent_session role — the same role the hosts already
   check before mounting the chat at all. */
export async function requestChatGrant() {
    // The empty object is not ceremony: dash_api parses the body before it routes, and answers
    // "Could not parse an empty JSON body" when axios sends the request without one.
    let response = await axios.post(AGENT_SESSION_PATH, {})
    let grant = (response.data || {}).grant
    if (!grant) {
        throw new Error("Agent auth session responded without a grant")
    }
    return grant
}
